var map = {
	"./pointer_1.gif": 1447,
	"./pointer_2.gif": 7136,
	"./pointer_3.gif": 2953,
	"./pointer_4.gif": 2962,
	"./pointer_5.gif": 683,
	"./pointer_6.gif": 5012,
	"./pointer_7.gif": 445,
	"./pointer_8.gif": 1190,
	"./pointer_9.gif": 8623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7565;